import { TUpcomingActivity } from "../../types";

export interface IUpcomingActivityType {
  isWorkoutRequest: boolean;
  isUpcomingRaceEntry: boolean;
}

export const getUpcomingActivityType = (
  upcomingActivity: TUpcomingActivity
): IUpcomingActivityType => ({
  isWorkoutRequest: "date" in upcomingActivity,
  isUpcomingRaceEntry: "raceDate" in upcomingActivity
});
